import React from 'react';
import HeroSection from '../components/brand/HeroSection';
import Pillars from '../components/brand/Pillars';
import Process from '../components/brand/Process';
import Showcase from '../components/brand/Showcase';
import Pakages from '../components/brand/Pakages';
import Testimonials from '../components/brand/Testimonials';
import FAQ from '../components/brand/FAQ';
import CTA from '../components/brand/CTA';

const Brand = () => {
  return (
    <>
      <HeroSection />
      <Pillars />
      <Process />
      <Showcase />
      <Pakages />
      <Testimonials />
      <FAQ />
      <CTA />
    </>
  )
}

export default Brand;